import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api/axios';

function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const [pendingUser, setPendingUser] = useState(null);
  const [role, setRole] = useState('job_seeker');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');
    const status = searchParams.get('status');
    const pendingStr = searchParams.get('pending');

    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);

        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));

        const roleRoutes = {
          admin: '/admin',
          employer: '/employer/jobs',
          recruiter: '/employer/jobs',
          agent: '/agent/dashboard',
        };
        window.location.replace(roleRoutes[user.role] || '/dashboard');
      } catch (error) {
        console.error('Invalid Google user data:', error);
        window.location.replace('/login?error=google_auth_failed');
      }
      return;
    }

    if (status === 'no_account' && pendingStr) {
      try {
        const pending = JSON.parse(decodeURIComponent(pendingStr));
        setPendingUser(pending);
      } catch (error) {
        console.error('Invalid pending user data:', error);
        window.location.replace('/login?error=google_auth_failed');
      }
      return;
    }

    console.error('Google OAuth callback missing token or user');
    window.location.replace('/login?error=google_auth_failed');
  }, [searchParams]);

  const handleCreateAccount = async () => {
    if (!pendingUser) return;
    setSubmitting(true);
    setError('');

    try {
      const res = await api.post('/auth/google/register-pending', {
        email: pendingUser.email,
        name: pendingUser.name,
        google_id: pendingUser.google_id,
        role,
      });

      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      const roleRoutes = {
        admin: '/admin',
        employer: '/employer/jobs',
        recruiter: '/employer/jobs',
        agent: '/agent/dashboard',
      };
      window.location.replace(roleRoutes[user.role] || '/dashboard');
    } catch (err) {
      console.error('Account creation failed:', err);
      setError(
        err.response?.data?.message || 'Could not create account. Please try again.'
      );
      setSubmitting(false);
    }
  };

  if (pendingUser) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="max-w-sm w-full bg-white rounded-xl shadow p-6 text-center">
          <h2 className="text-xl font-bold mb-2">No account found</h2>
          <p className="text-gray-500 mb-4">
            We couldn't find an account for <strong>{pendingUser.email}</strong>.
            Would you like to create one?
          </p>

          <div className="text-left mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              I am a
            </label>
            <select
              className="w-full border rounded-lg px-3 py-2"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              disabled={submitting}
            >
              <option value="job_seeker">Job Seeker</option>
              <option value="employer">Employer</option>
            </select>
          </div>

          {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

          <button
            onClick={handleCreateAccount}
            disabled={submitting}
            className="w-full bg-blue-600 text-white rounded-lg py-2 font-medium disabled:opacity-50"
          >
            {submitting ? 'Creating account...' : 'Create account'}
          </button>

          <button
            onClick={() => window.location.replace('/login')}
            disabled={submitting}
            className="w-full mt-2 text-gray-500 text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <p className="text-gray-500">Signing you in...</p>
      </div>
    </div>
  );
}

export default OAuthCallback;
